/**
 * Approval status values for companyUsers (and legacy users).
 * Must stay aligned with backend: backend/src/config/approvalStatus.ts (APPROVAL_STATUS),
 * backend/src/services/companyAuthService.ts, and Firestore usage.
 *
 * Used by: Login, CarrierLayout, OnboardingGuard, AdminDashboard, Register/BrokerRegister.
 * Do not repurpose for load/PO status (use statusValues.ts for those).
 */
export const APPROVAL_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
} as const;

export type ApprovalStatusValue =
  (typeof APPROVAL_STATUS)[keyof typeof APPROVAL_STATUS];
